import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Heart, ShoppingCart } from 'lucide-react';
import { useCart } from '@/contexts/CartContext';
import axios from 'axios';
import { PLACEHOLDER_IMG, handleImgError } from '@/lib/imagePlaceholder';

const API = window.location.origin + '/api';

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const fetchWishlist = async () => {
    try {
      const { data } = await axios.get(`${API}/wishlist`, { withCredentials: true });
      setItems(data);
    } catch (err) {
      console.error('Failed to fetch wishlist:', err);
    }
    setLoading(false);
  };

  useEffect(() => { fetchWishlist(); }, []);

  const removeFromWishlist = async (productId) => {
    await axios.post(`${API}/wishlist/${productId}`, {}, { withCredentials: true });
    setItems(prev => prev.filter(i => i.product_id !== productId));
  };

  const handleAddToCart = async (productId) => {
    try {
      await addToCart(productId);
    } catch (err) {
      console.error('Failed to add to cart from wishlist:', err);
    }
  };

  return (
    <div className="wishlist-page" data-testid="wishlist-page">
      <button className="back-btn" onClick={() => navigate('/')}>
        <ArrowLeft /> Home
      </button>
      <h2>My Wishlist</h2>
      {loading ? <div className="loading-screen">Loading...</div> :
        items.length === 0 ? (
          <div className="empty-state">
            <Heart size={64} />
            <h3>Wishlist is empty</h3>
            <p>Save your favorite products here</p>
          </div>
        ) : (
          <div className="product-list">
            {items.map(item => (
              <div className="product-card" key={item.product_id} data-testid={`wishlist-item-${item.product_id}`}>
                <div className="product-img-wrap">
                  <img src={item.product?.image_url || PLACEHOLDER_IMG} alt={item.product?.name} onError={handleImgError} />
                </div>
                <div className="product-info">
                  <p className="product-name">{item.product?.name}</p>
                  <p className="product-price">{item.product?.price?.toFixed(2)} PGK</p>
                </div>
                <div className="product-actions">
                  <button className="wishlist-btn active" onClick={() => removeFromWishlist(item.product_id)} data-testid={`remove-wishlist-${item.product_id}`}>
                    <Heart fill="currentColor" />
                  </button>
                  <button className="add-cart-btn" onClick={() => handleAddToCart(item.product_id)} data-testid={`add-to-cart-wishlist-${item.product_id}`}>
                    <ShoppingCart size={20} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )
      }
    </div>
  );
}
